import {InjectionToken} from "@angular/core";

/** Definerer metoder fra ajs {@link angular.material.IDialogService} som vi benytter i ng2-koden */
export interface AjsMdDialogService extends angular.material.IDialogService {
}

export const ajs_$mdDialog_DI_TOKEN = new InjectionToken<AjsMdDialogService>('ajs $mdDialog');
